import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { useNavigate } from 'react-router'
import { getDocumentsUrlWithCurrentParams } from '~/entities/document'
import { apiClient } from '~/shared/api/data-ingestion-api'
import { useSubmitPaMatch } from '../api'

export function useSubmitPaMatchingReview({ documentKey }: { documentKey: string }) {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const onSuccess = useCallback(() => {
    queryClient.invalidateQueries(
      apiClient.getDocumentDocumentsKeyGetOptions({
        path: { key: documentKey },
      }),
    )
    navigate(getDocumentsUrlWithCurrentParams())
  }, [documentKey, navigate, queryClient])

  const {
    mutateAsync: addPaMatchingReview,
    isError,
    isPending,
  } = useSubmitPaMatch({
    onSuccess,
  })

  const submitPaMatchingReview = useCallback(
    async (feedback: apiClient.PatientPaCaseMatchingFeedbackRequest) => {
      await addPaMatchingReview({
        path: { key: documentKey },
        body: feedback,
      })
    },
    [addPaMatchingReview, documentKey],
  )

  return {
    submitPaMatchingReview,
    isPaMatchingReviewError: isError,
    isPaMatchingReviewPending: isPending,
  }
}
